import {
  MtdItQuarters,
  OrganisationType,
  Priority,
  SmartTaskType,
  TaskStatus,
  TaskType,
  UpdateOnCompletion,
} from '@/shared/types/enum';
import { ScheduleDay } from '@/shared/types/schedule';
import {
  formatClassName,
  formatCompanyStatus,
  formatCompanyStatusDetail,
  formatDate,
  formatDayLongMonth,
  formatDayMonth,
  formatDayMonthYear,
  formatDayMonthYearTime,
  formatEnum,
  formatTime,
} from '@/shared/utils/format';
import { dueDateClass } from '@/shared/utils/style';

import { formatSearchResultName, formatSearchResultType } from '@/front/search';

const wrap = (formatter: (value: any) => string) => {
  return (value: any) => {
    try {
      return formatter(value);
    } catch (e) {
      console.error(e);
      return '';
    }
  };
};

(window as any).formatters = {
  dueDateClass: wrap(dueDateClass),
  formatClassName: wrap(formatClassName),
  formatDayMonth: wrap(formatDayMonth),
  formatDayLongMonth: wrap(formatDayLongMonth),
  formatDayMonthYear: wrap(formatDayMonthYear),
  formatDate: wrap(formatDate),
  formatTime: wrap(formatTime),
  formatDayMonthYearTime: wrap(formatDayMonthYearTime),
  formatSearchResultName: wrap(formatSearchResultName),
  formatSearchResultType: wrap(formatSearchResultType),
  formatOrganisationType: wrap((value: any) => formatEnum(OrganisationType, value)),
  formatTaskType: wrap((value: any) => formatEnum(TaskType, value)),
  formatTaskStatus: wrap((value: any) => {
    if (value === TaskStatus.StartDue) {
      return 'Start Overdue';
    }
    return formatEnum(TaskStatus, value);
  }),
  formatSmartTaskType: wrap((value: any) => formatEnum(SmartTaskType, value)),
  formatUpdateOnCompletion: wrap((value: any) => formatEnum(UpdateOnCompletion, value)),
  formatPriority: wrap((value: any) => formatEnum(Priority, value)),
  formatMtdItQuarters: wrap((value: any) => formatEnum(MtdItQuarters, value)),
  formatScheduleDay: wrap((value: any) => formatEnum(ScheduleDay, value)),
  formatCompanyStatus: wrap(formatCompanyStatus),
  formatCompanyStatusDetail: wrap(formatCompanyStatusDetail),
};
